import IconRightContainer from './IconRightContainer';
export default IconRightContainer;
//# sourceMappingURL=index.js.map